import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/g14142.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>

            <p className="home-about-body">
              Hey there!  I’m <b className="purple">Sheldon Onzere</b>, a passionate 
              <b className="purple"> Software Engineer </b> and 
              <b className="purple"> ICT Technician </b> from 
              <b className="purple"> Nairobi, Kenya.</b>  
              <br />
              <br />
              My passion lies in transforming creative ideas into real, functional, and scalable digital products.
              Whether it’s a mobile app, a web platform, or a connected system — I love building tech that makes life easier and smarter.
              <br />
              <br />
              I specialize in:
              <ul>
                <li>
                  <b className="purple">Mobile App Development</b> with Kotlin, React Native, Flutter, and Expo.
                </li>
                <li>
                  <b className="purple">Web Development</b> using React.js, Next.js, Node.js, and Firebase.
                </li>
                <li>
                   <b className="purple">Backend & APIs</b> with Express, PostgreSQL, MongoDB, and Firebase Functions.
                </li>
                <li>
                   <b className="purple">AI, IoT & Robotics</b> — integrating intelligent automation into real-world systems.
                </li>
              </ul>
              <br />
              I work comfortably with a wide tech stack including:
              <b className="purple"> Kotlin, dart, JavaScript, TypeScript, Java, Python, React.js, Node.js, MongoDB, PostgreSQL, Firebase,  Jupiter, and Pandas. </b>
              <br />
              <br />
              My toolset includes:
              <b className="purple">
                {" "}
                VS Code, Postman, Git, Android Studio, Slack, Vercel, macOS, and Windows 11.
              </b>
              <br />
              <br />
              I’m always exploring modern frameworks, cloud integrations, and automation tools to enhance performance, reliability, and user experience.
              <br />
              <br />
              <i>
                I believe great software isn’t just built — it’s crafted with
                <b className="purple"> passion, precision,</b> and a touch of creativity.
              </i>
            </p>
          </Col>

<Col md={4} className="myAvtar"> <Tilt> <img src={myImg} className="img-fluid" alt="avatar" id="profile" /> </Tilt> </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1> CONNECT WITH ME</h1>
            <p>
              I’m always open to <span className="purple">collaborations</span>, 
              <span className="purple"> freelance opportunities</span>, or just an insightful tech chat.  
              Let’s build something amazing together.
            </p>

            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Sheldon-codes/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://linkedin.com/in/sheldon-onzere/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://instagram.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>

            <p style={{ marginTop: "15px", color: "rgb(155 126 172)" }}>
              “Building tomorrow’s technology, one line of code at a time.” 🚀
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
